import { forwardRef } from 'react';

import classNames from 'classnames/bind';
import { Flex, Box, Typography } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import Spacer from 'shared_DEPRECATED/components/Spacer/Spacer';

import styles from 'features/chat/components/Chat.module.css';

type TChatMessageDeleted = { text?: string; incoming: boolean };

const cx = classNames.bind(styles);

export const ChatMessageDeleted = forwardRef<
  HTMLDivElement,
  TChatMessageDeleted
>(({ incoming, text = 'The message was deleted' }, ref) => (
  <Flex>
    <Box
      style={{
        display: 'flex',
        gap: '0.5rem',
        width: '100%',
        alignItems: 'center',
        justifyContent: incoming ? 'start' : 'end',
        flexDirection: incoming ? 'row' : 'row-reverse',
      }}
      data-testid="chat-message-selector"
    >
      <div
        className={cx(
          'chat__message',
          incoming ? 'chat__message--incoming' : 'chat__message--outgoing',
          'chat__message--deleted'
        )}
      >
        <Spacer size="md">
          <Flex w="100%" alignItems="center" justifyContent="center" gap="4px">
            <Icon name={iconNames.exclamationMark} />
            <Typography
              type="body"
              wordBreak="break-word"
              whiteSpace="pre-wrap"
              textAlign="left"
              dataTestid="chat-message-text"
            >
              {text}
            </Typography>
          </Flex>
          <div ref={ref} />
        </Spacer>
      </div>
    </Box>
  </Flex>
));
